var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarCheckIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  transform: "translate(0 0.5)",
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.9423 6.56754L7.94229 16.5675C7.88425 16.6256 7.81531 16.6717 7.73944 16.7032C7.66357 16.7347 7.58224 16.7508 7.5001 16.7508C7.41797 16.7508 7.33664 16.7347 7.26077 16.7032C7.18489 16.6717 7.11596 16.6256 7.05792 16.5675L2.68292 12.1925C2.56564 12.0753 2.49976 11.9162 2.49976 11.7503C2.49976 11.5845 2.56564 11.4254 2.68292 11.3082C2.80019 11.1909 2.95925 11.125 3.1251 11.125C3.29096 11.125 3.45002 11.1909 3.56729 11.3082L7.5001 15.2418L17.0579 5.68316C17.1752 5.56588 17.3343 5.5 17.5001 5.5C17.666 5.5 17.825 5.56588 17.9423 5.68316C18.0596 5.80044 18.1255 5.9595 18.1255 6.12535C18.1255 6.2912 18.0596 6.45026 17.9423 6.56754Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarCheckIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_check_icon.455194ee7585e1ae0802713b44f05447.svg";